import { createSlice, PayloadAction, createAsyncThunk } from '@reduxjs/toolkit';
import { ThunkAPI } from '@frameworks/redux';

import { getConfig } from '@config';
import { SettingsState, Theme } from '@types';

export const settingsInitialState: SettingsState = {
  stateVersion: 0,
  theme: 'light',
  devMode: {
    enabled: false,
    walletAddressOverride: '',
  },
};

const toggleDevMode = createAsyncThunk<
  { enabled: boolean },
  { enable: boolean },
  ThunkAPI
>('settings/toggleDevMode', async ({ enable }) => {
  const { ALLOW_DEV_MODE } = getConfig();
  return { enabled: enable && ALLOW_DEV_MODE };
});

const settingsSlice = createSlice({
  name: 'settings',
  initialState: settingsInitialState,
  reducers: {
    changeTheme: (state, action: PayloadAction<{ theme: Theme }>) => {
      state.theme = action.payload.theme;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(toggleDevMode.fulfilled, (state, { payload }) => {
      state.devMode.enabled = payload.enabled;
    });
  },
});

export const SettingsActions = { ...settingsSlice.actions, toggleDevMode };
export default settingsSlice.reducer;
